class AnimatedCount {

	constructor( node, duration = null, format = null ) {
		this.node     = node;
		this.duration = duration || this.node.dataset.duration || 1000;
		this.format   = format !== null ? format : this.node.dataset.format || false;
		this.text     = this.node.innerText;
		this.total    = parseInt( this.text.replace( /[^\d]/g, '' ), 10 );
		this.start    = null;
		this.animated = false;

		this.node.addEventListener( 'click', () => {
			this.animated = false;
			window.requestAnimationFrame( this.animate );
		} );

		this.animate = this.animate.bind(this);

		if ( window.IntersectionObserver ) {
			this.obeserver = new window.IntersectionObserver( entries => {
				entries.forEach( entry => {
					if ( ! this.animated && entry.isIntersecting ) {
						window.requestAnimationFrame( this.animate );
					}
				} );
			}, {
				root: null,
				rootMargin: '50px',
			} );

			this.obeserver.observe( this.node );
		} else {
			window.requestAnimationFrame( this.animate );
		}
	}

	animate( timestamp ) {
		if ( ! this.start ) {
			this.start          = timestamp;
			this.node.innerText = '0';
			this.animated       = true;
		}

		const elapsed    = timestamp - this.start;
		const percentage = elapsed / this.duration;

		let innerText = Math.min( Math.round( percentage * this.total ), this.total );

		if ( this.format ) {
			innerText = innerText.toLocaleString();
		}

		this.node.innerText = innerText;

		if ( percentage < 1 ) {
			window.requestAnimationFrame( this.animate );
		} else {
			this.node.innerText = this.format ? this.total.toLocaleString() : this.text;
			this.start = null;
		}
	}

}

export default AnimatedCount;
